import { TextInput, type UseFormReturn } from '@faceup/form'
import { defineMessages, useIntl } from '@faceup/localization'

const messages = defineMessages('followUp.pages.createReport.components.aFVictimNameField', [
  { id: 'victimNameLabel', defaultMessage: 'Who needs help?' },
] as const)

type Props = {
  form: UseFormReturn
  victimNameFieldId: string
}

export const AF_VictimNameField = ({ form, victimNameFieldId }: Props) => {
  const { formatMessage } = useIntl()

  return (
    <TextInput
      control={form.control}
      name={`${victimNameFieldId}.value`}
      label={formatMessage(messages.victimNameLabel)}
      withAsterisk
      autoComplete='off'
      data-test='create-school-report-form-victim-name-input'
      formItemProps={{
        'data-test': 'create-school-report-form-victim-name',
      }}
    />
  )
}
